import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    employees: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Construir el mensaje de WhatsApp con todos los datos del formulario
    let message = '🎯 *Solicitud de Demo - KREANDO Software*\n\n';
    message += `👤 *Nombre:* ${formData.name}\n`;
    message += `📧 *Email:* ${formData.email}\n`;
    message += `📱 *Teléfono:* ${formData.phone}\n`;
    
    if (formData.company) {
      message += `🏢 *Empresa:* ${formData.company}\n`;
    }
    
    if (formData.employees) {
      message += `👷 *Técnicos:* ${formData.employees}\n`;
    }
    
    if (formData.message) {
      message += `\n💬 *Mensaje:*\n${formData.message}`;
    }
    
    // Codificar el mensaje para URL
    const encodedMessage = encodeURIComponent(message);
    const phoneNumber = '51964206288';
    
    // Abrir WhatsApp con el mensaje
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
    
    // Limpiar el formulario
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      employees: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <h2 className="section-title">Agenda una Demo Gratuita</h2>
        <p className="section-subtitle">
          Descubre cómo nuestro software puede transformar tu empresa
        </p>
        <div className="contact-content">
          <div className="contact-info">
            <h3>¿Listo para empezar?</h3>
            <p>
              Agenda una llamada con nuestro equipo y te mostraremos cómo funciona el sistema.
              Sin compromiso.
            </p>
            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">📱</div>
                <div className="method-text">
                  <div className="method-label">WhatsApp</div>
                  <div className="method-value">+51 966 006 123</div>
                </div>
              </div>
              <div className="contact-method">
                <div className="method-icon">📧</div>
                <div className="method-text">
                  <div className="method-label">Email</div>
                  <div className="method-value">contacto@kreandosoftware.com</div>
                </div>
              </div>
              <div className="contact-method">
                <div className="method-icon">📅</div>
                <div className="method-text">
                  <div className="method-label">Horario</div>
                  <div className="method-value">Lun - Vie: 9:00 - 18:00</div>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-form">
            <h3>Solicita tu Demo</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre completo *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Juan Pérez"
                />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="juan@empresa.com"
                />
              </div>
              <div className="form-group">
                <label>Teléfono / WhatsApp *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="+51 964 206 288"
                />
              </div>
              <div className="form-group">
                <label>Empresa</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Nombre de tu empresa"
                />
              </div>
              <div className="form-group">
                <label>¿Cuántos técnicos tienes?</label>
                <select
                  name="employees"
                  value={formData.employees}
                  onChange={handleChange}
                >
                  <option value="">Selecciona una opción</option>
                  <option value="1-3">1-3 técnicos</option>
                  <option value="4-10">4-10 técnicos</option>
                  <option value="11-20">11-20 técnicos</option>
                  <option value="20+">Más de 20 técnicos</option>
                </select>
              </div>
              <div className="form-group">
                <label>Mensaje (opcional)</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Cuéntanos sobre tu empresa y necesidades..."
                />
              </div>
              <button type="submit" className="btn btn-primary form-submit">
                Agendar Reunión Gratis
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
